<template lang='pug'>
div.upload
  upload-cadastro(
    ref='resumable',
    class='resumable',
    :target='targetUpload',
    @onSuccess='onSuccess',
    @onError='onError'
    @fileProgress='fileProgress',
    @onProgress="onProgress"
  )
</template>

<script>
import UploadCadastro from '@/components/Importacao/UploadCadastro'
import { mapActions } from 'vuex'

export default {
  components: {
    UploadCadastro
  },
  data () {
    return { percentage: 0, progressVisible: false }
  },
  computed: {
    targetUpload () {
      return 'publico/uploadcadastro/upload'
    }
  },

  methods: {
    ...mapActions({
      createByFilekey: 'upload/createCadastroByFilekey',
      resetLoader: 'loader/resetLoader',
      setLoaderWithText: 'loader/setLoaderWithText'
    }),

    onSuccess (file, fileKey) {
      this.importFile(fileKey, file)
    },

    onError (err) {
      this.progressVisible = false
      this.resetLoader()
      this.$refs.resumable.removeFile()
      const response = {
        data: err
      }
      this.$emit('uploadFail', { response })
    },

    onProgress (percentage) {
      this.percentage = percentage
      if (this.percentage <= 100 && this.progressVisible) {
        let msg = ''
        if (this.percentage < 100) {
          msg = `${this.percentage}% concluído...`
        } else {
          msg = '100% concluído. Aguarde, finalizando importação...'
        }
        this.setLoaderWithText({
          status: true,
          text: msg
        })
      }
    },

    fileProgress () {
      this.percentage = 0
      this.progressVisible = true
      this.setLoaderWithText({
        status: true,
        text: `${this.percentage} % concluído...`
      })
    },

    async importFile (fileKey, file) {
      try {
        const result = await this.createByFilekey(fileKey)
        this.resetLoader()
        this.progressVisible = false
        this.$emit('uploadSuccess', result)
        this.$emit('selectedFile', file)
      } catch (error) {
        this.onError(error)
      }
    }
  }
}
</script>

<style lang='scss' scoped>
.upload {
  height: 100%;
}
.resumable {
  height: 100%;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/AppUploadTusCadastro.vue